import { skipToken, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { usePublishedContext } from '@/components/views/published/PublishedContext';
import type { ItemTypeLevel } from '@/lib/api/types/itemType';
import { itemTypeLevelsQueryOptions } from '@/lib/queries/common/useItemTypeLevelsQuery';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const useItemTypeLevelsQueryWithPublished = (
  options: Partial<UseQueryOptions<ItemTypeLevel[]>> = {},
) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const levelsQuery = useQuery({
    ...itemTypeLevelsQueryOptions(),
    ...options,
    enabled: !isPublished && options.enabled !== false,
  });

  const publishedQuery = useQuery<ItemTypeLevel[] | undefined>({
    queryKey: [...commonQueryKeys.itemTypeLevels.all, 'published'],
    queryFn: skipToken,
    initialData: () => publishedContext?.itemTypeLevels,
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return isPublished ? publishedQuery : levelsQuery;
};
